export default "__VITE_ASSET___szx9W$i__"